import { useQuery } from "@apollo/client";
import { Spinner } from "../../../components/Spinner";
import "../css/style.css";
import { ArticleListQuery, ArticleListResponse } from "../helper/graphql";
import { ArticleListView } from "./ListView";

type ArticleListViewControllerProps = {};

export const ArticleTableViewController = (
  props: ArticleListViewControllerProps
) => {
  const { loading, data, error, refetch } = useQuery<ArticleListResponse>(
    ArticleListQuery,
    {
      fetchPolicy: "no-cache",
    }
  );

  if (loading) return <Spinner />;

  if (data) return <ArticleListView data={data} refetch={refetch} />;

  console.log("got error", error);

  return <p>Error!</p>;
};
